<script>
  import Fa from "svelte-fa"
  import { faTrashCan } from "@fortawesome/free-regular-svg-icons"

  import Rating from "./Rating.svelte"

  export let id
  export let history
</script>

<main class="flex flex-col gap-4 mt-6">
  <div
    class="flex flex-row border-b border-dashed border-slate pb-2 items-center"
  >
    <div class="grow text-lg font-light thick">History</div>
  </div>
  {#each history as record}
    <a
      href="/recipes/{id}/preparations/{record.id}"
      class="flex flex-row items-center gap-2 text-xl md:text-lg text-fg hover:text-accent"
    >
      <Rating rating={record.rating} compact={true} />
      {record.date}
    </a>
  {/each}
</main>
